import { gql } from '@apollo/client';

import { EscrowMembershipFragment } from './escrowMemberships.fragment';

export * from './escrowMembershipCreate.mutation.generated';

export const ESCROW_MEMBERSHIP_CREATE = gql`
  mutation escrowMembershipCreate($input: EscrowMembershipCreateInput!) {
    escrowMembershipCreate(input: $input) {
      errors
      success
      escrowMembership {
        ...EscrowMembershipFragment
      }
    }
  }
  ${EscrowMembershipFragment}
`;
